import "./dump";
import "./network";
import "./playbackInfo";

/**
 * JSON Schema for the parameter object.
 *
 * http://json-schema.org/
 */
export default {
  id: "/Parameter",
  type: "object",
  properties: {
    errorCode: { type: "string" },
    userId: { type: "string" },
    screenName: { type: "string" },
    authToken: { type: "string" },
    device: { $ref: "/Device" },
    type: { type: "string" },
    appLanguage: { type: "string" },
    appVersion: { type: "string" },
    dump: { $ref: "/Dump" },
    network: { $ref: "/Network" },
    playbackInfo: { $ref: "/Playback" }
  },
  required: ["errorCode"]
};
